import {createElement, PropTypes, cloneElement, Children} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';


export default class RepeatingInput extends InputBase {
  get inputType () {
    return 'repeating';
  }
  get addButtonLabel () {
    return this.fromPropsOrContext('addButtonLabel');
  }
  get removeButtonLabel () {
    return this.fromPropsOrContext('removeButtonLabel');
  }

  get newElementValue () {
    return this.fromPropsOrContext('newElementValue');
  }

  get childTitle () {
    return this.fromPropsOrContext('childTitle');
  }

  get mapChildProps () {
    return this.fromPropsOrContext('mapChildProps');
  }

  get value () {
    return super.value || [];
  }


  hasValue (value) {
    let normalized = this.normalizeValue(value);
    return normalized && normalized.length > 0;
  }

  fireCommitValue (ev, ...args) {
    if (ev.type !== 'forcecommit') {
      super.fireCommitValue(ev, ...args);
    }
  }



  addValue (ev) {
    ev.preventDefault();
    let value = this.value.concat([this.newElementValue]);
    let changes = [
      ['AppendContentValue', {
        newValue: this.newElementValue,
      }],
    ];
    this.handleChange({
      event: ev,
      value,
      changes,
    });
    this.fireCommitValue(ev, value, changes);
  }
  removeValue (ev, idx) {
    ev.preventDefault();
    let value = this.value.slice(0, idx - 1).concat(this.value.slice(idx));
    let changes = [
      ['RemoveContentValue', {
        valuePath: [idx],
      }],
    ];
    this.handleChange({
      event: ev,
      value,
    });
    this.fireCommitValue(ev, value, changes);
  }

  renderRepeatingInput (value, idx) {
    if (this.mapChildProps) {
      return Children.map(this.props.children, child => cloneElement(child,
        this.mapChildProps(idx, this, child)));
    } else {
      return this.props.children;
    }


  }
  renderInput () {
    return (<div>
      <ul>
        {this.value.map((value, idx) => (<li key={idx}>
          <fieldset>
            <legend><h3>{`${this.childTitle} ${idx + 1}`}</h3></legend>
            <button onClick={ev => this.removeValue(ev, idx)}>
              {this.removeButtonLabel}
            </button>
            {this.renderRepeatingInput(value, idx)}
          </fieldset>
        </li>))}
      </ul>
      <button onClick={ev => this.addValue(ev)}>{this.addButtonLabel}</button>
    </div>);
  }

}
mergeStaticOptions(RepeatingInput, {
  propTypes: {
    addButtonLabel: PropTypes.node,
    removeButtonLabel: PropTypes.node,
    newElementValue: PropTypes.any,
    childTitle: PropTypes.node,
    mapChildProps: PropTypes.func,
  },
  defaultProps: {
    addButtonLabel: 'Add',
    removeButtonLabel: 'Remove',
    newElementValue: null,
    childTitle: '',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/RepeatingInput.jsx